<div (mouseleave)="onMouseOver()" class="wrapper" >
  <div class="content"></div>
  <div [ngClass]="{emptySubList: !subItems()?.length}" class="header">
    <span>{{titleSubItems() | translate }}</span>
  </div>

  @if (subItems()) {
    <div class="menu">
      <app-sub-list-nav-bar [expanded]="true" [subItems]="subItems()"/>
    </div>
  }
</div>
